import React, {Fragment, useEffect, useState} from "react";

// reactstrap components
import {
    Button,
    Card,
    CardFooter,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText, Modal,
    Row,
    Table, UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import PaginationWrapper from "../components/pagination";
import {paginate, telWithCommas} from "../../../utils";
import useHistoryState from "../../../common/useHistoryState";
import moment from "moment";
import {useHistory} from "react-router";
import storeService from "./service/store.service";
import classnames from "classnames";
import AuthService from "../auth/auth.service";
import {Link} from "react-router-dom";
import charityService from "../charity/service/charity.service";

function StoreList() {
    const user = typeof window !== 'undefined' ? AuthService.getCurrentUser() : null;
    const history = useHistory();
    const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
    const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
    const [data, setData] = useHistoryState([], 'data');
    const [diff, setDiff] = useHistoryState('', 'diff');
    const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
    const [search, setSearch] = useHistoryState('', 'search');
    // console.log('123',user)

    const render = () => {
        let option = { };
        if (search) {
            option.search = search;
        }
        if (pageCount) {
            option.page = pageActive;
        }
        storeService.list({ page: pageActive, search, category: '포아브가맹점배달가능'})
            .then((res) => {
                if (res.code === 200) {
                    console.log(res);
                    setPageCount(res.storeList.count);
                    // setData(paginate(res.centers.rows, pageActive, 11));
                    setData(res.storeList.rows);
                }
            });
    };

    useEffect(() => {
        render();
    }, [search, pageActive, pageCount]);

    const statusChange = async (id, check) => {
        await storeService.update(id, {check});
        render();
    }

    return (
        <>
            <SimpleHeader name="Tables" parentName="Tables" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader className="border-0">
                                <Row className="py-3">
                                    <Col xs="11">
                                        <Form>
                                            <Row>
                                                <Col xs="3">
                                                    <label className=" form-control-label py-2">
                                                    </label>
                                                    <FormGroup>
                                                        <InputGroup
                                                            className={classnames("input-group-merge", {
                                                                focused: searchCurrent,
                                                            })}
                                                        >
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="fas fa-search" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                // placeholder="제목으로 검색"
                                                                type="text"
                                                                value={search}
                                                                onChange={(e) => setSearch(e.target.value)}
                                                                onFocus={(e) => setSearchCurrent(true)}
                                                                onBlur={(e) => setSearchCurrent(false)}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="6">
                                        <h3 className="mt-2">
                                            가맹점 관리
                                        </h3>
                                    </Col>
                                    {user?.role === 'center' ? null : (
                                      <Col className="text-right">
                                          <Button
                                              color="default"
                                              onClick={(e) => history.push('/admin/centerForm')}
                                          >
                                              등록하기
                                          </Button>
                                      </Col>
                                    )}
                                </Row>
                            </CardHeader>

                            <Table className="align-items-center table-flush" responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="text-center">상점명</th>
                                        <th className="text-center">주소</th>
                                        <th className="text-center">전화번호</th>
                                        <th className="text-center">담당자 전화번호</th>
                                        <th className="text-center">등록일</th>
                                        <th className="text-center">활성화</th>
                                        <th className="text-center">관리</th>
                                        <th className="text-center">매장</th>
                                        <th className="text-center">메뉴</th>
                                        <th className="text-center">스케줄</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, i) => {
                                        return [
                                            <Fragment key={i}>
                                                <tr>
                                                    <td className="text-center">
                                                        {item.name}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.address}
                                                    </td>
                                                    <td className="text-center">
                                                        {telWithCommas(item.tel)}
                                                    </td>
                                                    <td className="text-center">
                                                        {telWithCommas(item.managerTel)}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.createdAt}
                                                    </td>
                                                    <td className="text-center">
                                                        <label className="custom-toggle custom-toggle-success center">
                                                            <input
                                                                checked={item.active}
                                                                type="checkbox"
                                                                onChange={(e) => statusChange(item.id, !item.active)}
                                                            />
                                                            <span
                                                                className="custom-toggle-slider rounded-circle"
                                                                data-label-off="No"
                                                                data-label-on="Yes"
                                                            />
                                                        </label>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            className="btn-outline-warning"
                                                            color="danger"
                                                            // onClick={() => setDefaultModal(true)}
                                                            size="sm"
                                                        >
                                                            <span className="btn-inner--text">삭제</span>
                                                        </Button>
                                                        <Button
                                                            className="btn-outline-warning"
                                                            color="danger"
                                                            // onClick={() => setDefaultModal(true)}
                                                            size="sm"
                                                        >
                                                            <span className="btn-inner--text">상세</span>
                                                        </Button>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            className="btn-outline-yellow"
                                                            // color="danger"
                                                            // onClick={() => setDefaultModal(true)}
                                                            size="sm"
                                                        >
                                                            <span className="btn-inner--text">관리</span>
                                                        </Button>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            className="btn-outline-purple"
                                                            // color="danger"
                                                            // onClick={() => setDefaultModal(true)}
                                                            size="sm"
                                                        >
                                                            <span className="btn-inner--text">관리</span>
                                                        </Button>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            className="btn-outline-danger"
                                                            color="danger"danger
                                                            // onClick={() => setDefaultModal(true)}
                                                            size="sm"
                                                        >
                                                            <span className="btn-inner--text">관리</span>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        ];
                                    })}
                                </tbody>
                            </Table>

                            <CardFooter className="py-4">
                                <PaginationWrapper
                                    isActive={pageActive}
                                    pageNumber={pageCount}
                                    callback={(page) => setPageActive(page)}
                                    itemPerPage={10}
                                />
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default StoreList;
